import React from 'react'
import Navbar from '../../components/navbar'

import heroImg from '../../assets/images/job/hero.svg'
import Partner from '../../components/partner'
import { Link } from 'react-router-dom'
import { jobCategory, jobData } from '../../data/job'
import cta from '../../assets/images/job/cta.jpg'
import ClientTwo from '../../components/client-two'

import {FiAirplay, FiMapPin, FiArrowRight } from '../../assets/icons/vander'

import Footer from '../../components/footer'

export default function IndexCareer() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 d-table w-100 bg-light">
      <div className="container">
          <div className="row mt-5 align-items-center">
              <div className="col-md-6">
                  <div className="title-heading">
                      <h4 className="heading mb-3 fw-bold">Search your dream jobs <br/> with Leaping<span className="text-primary">.</span></h4>
                      <p className="text-muted para-desc mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  
                      <div className="subcribe-form mt-4 pt-2">
                          <form action="#">
                              <input type="text" id="keywords" name="name" className="shadow rounded-pill" required placeholder="Search your Keywords.."/>
                              <button type="submit" className="btn btn-primary rounded-pill">Search</button>
                          </form>
                      </div>
                      <p className="text-muted mb-0 mt-3"><span className="text-dark">Keywords :</span> Web designer, Web developer, etc...</p>
                  </div>
              </div>

              <div className="col-md-6">
                  <img src={heroImg} className="img-fluid" alt=""/>
              </div>
          </div>
      </div>
    </section>

    <section className="py-5 bg-light border-top">
      <div className="container">
          <Partner/>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12">
                  <div className="section-title mb-4 pb-2 text-center">
                      <h4 className="title mb-4">Explore the catagories</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {jobCategory.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2" key={index}>
                      <div className="d-flex rounded shadow p-3 align-items-center">
                          <div className="icons text-primary h3 mb-0">
                              <Icon className=""/>
                          </div>

                          <div className="flex-1 content ms-3">
                              <Link to="#" className="title text-dark h5 mb-0 d-block">Design & Art</Link>
                              <small className="text-muted sub-title">7 Opening</small>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
    </section>

    <section style={{backgroundImage:`url(${cta})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-6">
                  <div className="cta-review bg-primary shadow rounded p-4">
                      <ClientTwo/>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container mt-5 pt-4">
          <div className="row align-items-end mb-4 pb-2">
              <div className="col-md-8">
                  <div className="section-title text-center text-md-start">
                      <h4 className="title mb-4">Find the perfect jobs</h4>
                      <p className="text-muted mb-0 para-desc">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>

              <div className="col-md-4 mt-4 mt-sm-0 d-none d-md-block">
                  <div className="text-center text-md-end">
                      <Link to="/page-jobs" className="text-primary">View more Jobs <FiArrowRight className="fea icon-sm"/></Link>
                  </div>
              </div>
          </div>

          <div className="row">
            {jobData.slice(0,6).map((item,index)=>{
              return(
                  <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="card border-0 bg-light rounded shadow">
                          <div className="card-body p-4">
                              <span className="badge rounded-pill bg-primary float-md-end mb-3 mb-sm-0">{item.jobType}</span>
                              <h5>{item.title}</h5>
                              <div className="mt-3">
                                  <span className="text-muted d-flex align-items-center mb-2"><FiAirplay className="text-primary h6 mb-0 me-1"/> <Link to="https://1.envato.market/leaping" target="_blank" className="text-muted">{item.name}</Link></span>
                                  <span className="text-muted d-flex align-items-center"><FiMapPin className="text-primary h6 mb-0 me-1"/> {item.country}</span>
                              </div>
                              
                              <div className="mt-3">
                                  <Link to={`/page-job-detail/${item.id}`} className="btn btn-primary">View Details</Link>
                              </div>
                          </div>
                      </div>
                  </div>
              )
            })}

              <div className="col-12 mt-4 pt-2 d-block d-md-none text-center">
                  <Link to="/page-jobs" className="btn btn-primary">View more Jobs <i data-feather="arrow-right" className="fea icon-sm"></i></Link>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="bg-dark bg-cta-dark rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h3 className="text-white title-dark mb-0">Let's get connected and start finding your dream job</h3>
                      </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="#" className="btn btn-outline-primary">Create free account</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    
    <Footer/>
    </>
  )
}
